export const ADD_BIN_COLLECTION_SUCCESS = 'ADD_BIN_COLLECTION_SUCCESS'
